<template>
        <label class="d-block">
            Quality Check Name
            <input v-model="c.name" type="text" class="form-control">
        </label>
        <!-- DEV-2885: absent for Theta Lake — exactly one check is allowed, so there is nothing for
             a default to distinguish -->
        <label v-if="config.showDefaultCheckbox" class="d-block"><input type="checkbox" v-model="c.default"> {{ config.defaultCheckLabel }} </label>
        <label v-if="config.showSyndicate" class="d-block"><input type="checkbox" v-model="c.meta.should_send_to_syndicate"> Should Send to
            Syndicate </label>
        <!-- absent for Theta Lake: policies are configured on their side and apply to
             whatever we ingest, so there is no picker and no ID field replacing it. -->
        <!-- `c.meta.external_ids` is guaranteed by upgradeCheck for providers that show this field,
             but guard anyway: v-model into an undefined object throws and blanks the whole form. -->
        <label v-if="config.showConfigExternalId && c.meta && c.meta.external_ids" class="d-block">
            {{ config.configExternalIdLabel }}
            <input v-model="c.meta.external_ids.success_flag" class="form-control"/>
            <small class="text-muted">{{ config.configExternalIdHelp }}</small>
        </label>
        <table class="table" v-if="c.statuses">
            <thead>
            <tr>
                <th>Style/Icon</th>
                <!--<th>Key</th>-->
                <th>Name</th>
                <th>Severity</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="s in editableStatuses" :key="s.id ? s.id : s.severity">
                <td>
                    <span class="tag" :class="s.tag_class">
                        <i :class="s.icon_class"></i>
                    </span>
                </td>
                <!--<td>{{s.status_key}}</td>-->
                <td><input v-model="s.status_label" class="form-control form-control-sm"/></td>
                <td>{{ getSeverity(s.severity) }}</td>
            </tr>
            </tbody>
        </table>
        <button
            v-if="!isNewCheck"
            type="button"
            @click="handleSave"
            class="btn btn-success mx-2"
            :disabled="networkActivity"
        >
            <spinner v-if="networkActivity" class="d-inline-block"></spinner>
            Save
        </button>
        <button
            v-else
            type="button"
            @click="handleSave"
            class="btn btn-success mx-2"
            :disabled="networkActivity"
        >
            <spinner v-if="networkActivity" class="d-inline-block"></spinner>
            Add check
        </button>
    <hr>
</template>
<script>
import Spinner from "@/components/Controls/Spinner"
// Aliased: the `providerConfig` prop below would otherwise shadow it confusingly.
import {SEVERITY, providerConfig as resolveProviderConfig} from '@/components/QualityChecks/qualityCheckProviders'

export default {
    name: 'QualityCheckForm',
    components: {Spinner},
    props: {
        c: { type: Object, required: true },
        getSeverity: { type: Function, required: true },
        networkActivity: { type: Boolean, default: false },
        save: { type: Function, required: true },
        isNewCheck: { type: Boolean, required: true },
        // DEV-2885: optional so any caller that has not been updated still renders as Proofpoint.
        providerConfig: { type: Object, default: null },
    },
    computed: {
        config() {
            // A saved check's own type wins, so it always renders with its own provider's fields
            // even if the passed config disagrees. A new check has no type yet, so the config the
            // parent passed decides. Falls back to Proofpoint for callers that pass neither.
            if (this.c.type) return resolveProviderConfig(this.c.type);
            return this.providerConfig || resolveProviderConfig();
        },
        /**
         * Rows the user can edit.
         *
         * Proofpoint hides severity 6 (ERROR): its API collapses ERROR onto the `inconclusive`
         * status key, so an editable row would imply independent wording it cannot have, and
         * `QualityChecks.save()` overwrites it anyway. Theta Lake gives ERROR its own `error` key,
         * so the row is shown and its label is kept.
         */
        editableStatuses() {
            const statuses = this.c.statuses || [];
            return this.config.collapseErrorOntoInconclusive
                ? statuses.filter(x => x.severity !== SEVERITY.ERROR)
                : statuses;
        }
    },
    methods: {
        handleSave() {
            this.save(this.c);
        }
    }
}
</script>
